export const ApiUrl = 'https://sorocabainteligente.appcidadeinteligente.com.br/api'